import { Close } from "@mui/icons-material";
import { Box, Dialog, DialogContent, DialogTitle, Fade, IconButton, Modal, Skeleton } from "@mui/material";
import { useEffect, useState } from "react";
// import { getFile } from "../apis/file.api";
import { TransformComponent, TransformWrapper } from "react-zoom-pan-pinch";
import { getFileOrImage } from "../apis/file.api";


const ImageComponent = ({ src, alt, sx = {}, noClickEffect, isStatic, ...props }) => {
    const [loading, setLoading] = useState(true)
    const [open, setOpen] = useState(false);
    const handleOpen = () => {
        if (!noClickEffect) {
            // setLoading(true)
            setOpen(true);
        }
    };
    const handleClose = () => {
        setOpen(false);
    };

    const fetchImage = async () => {
        setLoading(true)
        const file = await getFileOrImage({fileUrl:src})

        setImage(URL.createObjectURL(file))

        setLoading(false)
    }
    const [img, setImage] = useState(isStatic ? src : null)

    useEffect(() => {
        if (!isStatic)
            fetchImage()
    }, [src])

    return (

        <>
            <Dialog

                open={open}
                onClose={handleClose}
                TransitionComponent={Fade}
                fullWidth
            >
                <DialogTitle sx={{ justifyContent: "flex-end", display: "flex" }}>
                    <IconButton onClick={handleClose}>
                        <Close />
                    </IconButton>
                </DialogTitle>
                <DialogContent sx={{ overflow: "hidden", display: "flex" }} >

                    <Box sx={{ width: "100%", maxHieght: "100%", background: "lightgray", position: "relative" }}>
                        <TransformWrapper
                            smooth
                            style={{ height: "100%", width: "100%" }}
                            initialScale={1}
                        >
                            <TransformComponent style={{ height: "100%", width: "100%" }}>

                                <img onLoad={() => { setLoading(false) }} src={img} alt={alt} style={{ width: "100%", height: "100%", objectFit: "contain" }} {...props} />

                            </TransformComponent>
                        </TransformWrapper>

                    </Box>
                    {/* </Box> */}
                </DialogContent>
            </Dialog>

            <Box sx={{ width: "100%", position: "relative", height: "100%",minHeight:"100px" }}>
                {loading && <Box sx={{ position: "absolute", top: "0px", left: "0px", width: "100%", height: "100%", minHeight: "200px" }}>
                    <Skeleton sx={{ height: "100%", width: "100%" }} variant="rounded" animation="wave">

                    </Skeleton>
                </Box>}
                <img src={img} onLoad={() => { setLoading(false) }} alt={alt} style={{ objectFit: "cover", width: "100%", height: "100%", ...sx, cursor: noClickEffect ? "default" : "pointer" }} {...props} onClick={handleOpen} />
            </Box>

        </>)
}
export default ImageComponent


export const PdfComponent = ({ src, alt, sx = {}, ...props }) => {
    const [loading, setLoading] = useState(true)
    const [open, setOpen] = useState(false);
    const handleOpen = () => {

        setLoading(true)
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };


    return (

        <> <Dialog

            open={open}
            onClose={handleClose}
            TransitionComponent={Fade}
            fullWidth
        >
            <DialogTitle sx={{ justifyContent: "flex-end", display: "flex" }}>
                <IconButton onClick={handleClose}>
                    <Close />
                </IconButton>
            </DialogTitle>
            <DialogContent   >

                <Box sx={{ width: "100%", background: "lightgray", position: "relative" }}>

                    <embed onLoad={() => { setLoading(false) }} src={src} alt={alt} style={sx} {...props} onClick={handleOpen} />

                </Box>
            </DialogContent>
        </Dialog>

            <Box sx={{ width: "100%", position: "relative" }}>
                {loading && <Box sx={{ position: "absolute", top: "0px", left: "0px", width: "100%", height: "100%", minHeight: "200px" }}>
                    <Skeleton sx={{ height: "100%", width: "100%" }} animation="wave">

                    </Skeleton>
                </Box>}
                <Box sx={{ border: "2px solid grey", borderRadius: "10px", display: "flex", alignItems: "flex-end", flexDirection: "column", background: "grey" }}>
                    {/* <IconButton onClick={handleOpen}>
                        <FileOpen color="light" />
                    </IconButton> */}
                    <embed src={src} onLoad={() => { setLoading(false) }} alt={alt} style={{ ...sx, height: "500px", cursor: "pointer" }} {...props} />
                </Box>


            </Box>

        </>)
}

